import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../core/_config/app.config';
import { DownloadedFile } from '../views/pages/file-remitance/models/downloadFile';

@Injectable({
    providedIn: 'root',
})
export class FileService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig) {}

    extractFileNameAndBlobService(httpResponse: HttpResponse<ArrayBuffer>): DownloadedFile {
        const headers = httpResponse.headers;
        const contentDisposition = headers.get('Content-Disposition');

        if (contentDisposition == null) {
            throw new Error(`Server Error: Cannot retrieve file name.
      Either Content-Dispostion header is not available or it is not exposed using Access-Control-Expose Header.`);
        }

        const fileNameItem = contentDisposition
            .split(';')
            .map((item) => item.trim())
            .find((item) => item.toLowerCase().startsWith('filename='));
        if (fileNameItem == null) {
            throw new Error(`Server didn't send a filename`);
        }

        let fileName = fileNameItem.split('=')[1];
        if (fileName.startsWith('"')) fileName = fileName.substring(1, fileName.length - 1);

        const contentType = headers.get('Content-Type');
        const blob = new Blob([httpResponse.body], { type: contentType });
        return {
            blob: blob,
            fileName: fileName,
        };
    }

    downloadFile(file: DownloadedFile) {
        //IE ::VERIFICAR
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file.blob);
            return;
        }

        const blob = window.URL.createObjectURL(file.blob);
        const link = document.createElement('a');
        link.href = blob;
        link.download = file.fileName;

        link.dispatchEvent(
            new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            }),
        );

        setTimeout(() => {
            window.URL.revokeObjectURL(blob);
            link.remove();
        }, 200);
    }
}
